import { createV3Queries } from "@query/utils/createV3Queries";
import { deductionsApi } from "@api";

export const queriesDeductions = createV3Queries(
  "deductionsApi",
  deductionsApi
);
